import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-match-incidents',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-match-incidents.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonMatchIncidentsComponent {
  arrIncidents = Array.from({ length: 4 });
  arrItemByIncidents = Array.from({ length: 4 });
}
